
import React from "react";
import TocTocHeader from "@/components/TocTocHeader";
import TocTocPortfolio from "@/components/TocTocPortfolio";
import TocTocCTA from "@/components/TocTocCTA";
import TocTocFooter from "@/components/TocTocFooter";

import SEOHead from "@/components/common/SEOHead";

const Portfolio = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": ["WebPage", "CollectionPage"],
        "@id": "https://site.toctocbr.com/portfolio#webpage",
        url: "https://site.toctocbr.com/portfolio",
        name: "Portfólio | Toc Toc",
        inLanguage: "pt-BR",
        about: [
          "fotografia imobiliária",
          "fotografia de arquitetura",
          "fotografia de interiores",
          "filmmaker imobiliário",
          "Airbnb"
        ],
        isPartOf: { "@id": "https://site.toctocbr.com/#website" }
      },
      {
        "@type": "WebSite",
        "@id": "https://site.toctocbr.com/#website",
        url: "https://site.toctocbr.com/",
        name: "Toc Toc",
        inLanguage: "pt-BR",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://site.toctocbr.com/?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": ["Organization", "LocalBusiness", "ProfessionalService"],
        "@id": "https://site.toctocbr.com/#org",
        name: "Toc Toc",
        url: "https://site.toctocbr.com/",
        logo: "https://site.toctocbr.com/logo.png",
        description:
          "Fotografia imobiliária profissional, fotografia de arquitetura e interiores, filmmaker (vídeos imobiliários) e fotografia para Airbnb em Santa Catarina.",
        telephone: "+55-47-99736-7396",
        email: "contato@toctocbr.com",
        sameAs: ["https://www.instagram.com/toctoc.br"],
        areaServed: [
          { "@type": "City", name: "Balneário Camboriú" },
          { "@type": "City", name: "Camboriú" },
          { "@type": "City", name: "Itajaí" },
          { "@type": "City", name: "Itapema" },
          { "@type": "City", name: "Porto Belo" },
          { "@type": "City", name: "Bombinhas" },
          { "@type": "City", name: "Navegantes" },
          { "@type": "State", name: "Santa Catarina" },
          { "@type": "Country", name: "Brasil" }
        ]
      },
      {
        "@type": "ImageGallery",
        "@id": "https://site.toctocbr.com/portfolio#galeria",
        name: "Portfólio de Fotografia Imobiliária e Arquitetura",
        url: "https://site.toctocbr.com/portfolio",
        hasPart: [
          { "@id": "https://site.toctocbr.com/portfolio#item-residencial-1" },
          { "@id": "https://site.toctocbr.com/portfolio#item-interiores-1" },
          { "@id": "https://site.toctocbr.com/portfolio#item-comercial-1" },
          { "@id": "https://site.toctocbr.com/portfolio#item-airbnb-1" }
        ]
      },
      {
        "@type": "ItemList",
        "@id": "https://site.toctocbr.com/portfolio#lista-trabalhos",
        name: "Trabalhos em destaque",
        itemListOrder: "http://schema.org/ItemListOrderAscending",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: { "@id": "https://site.toctocbr.com/portfolio#item-residencial-1" }
          },
          {
            "@type": "ListItem",
            position: 2,
            item: { "@id": "https://site.toctocbr.com/portfolio#item-interiores-1" }
          },
          {
            "@type": "ListItem",
            position: 3,
            item: { "@id": "https://site.toctocbr.com/portfolio#item-comercial-1" }
          },
          {
            "@type": "ListItem",
            position: 4,
            item: { "@id": "https://site.toctocbr.com/portfolio#item-airbnb-1" }
          }
        ]
      },
      {
        "@type": "CreativeWork",
        "@id": "https://site.toctocbr.com/portfolio#item-residencial-1",
        name: "Apartamento de luxo com vista para o mar — Fotografia Imobiliária",
        genre: "fotografia imobiliária",
        url: "https://site.toctocbr.com/portfolio",
        about: ["residencial", "apartamento", "vista mar", "Balneário Camboriú"]
      },
      {
        "@type": "CreativeWork",
        "@id": "https://site.toctocbr.com/portfolio#item-interiores-1",
        name: "Quarto minimalista — Fotografia de Interiores",
        genre: "fotografia de interiores",
        url: "https://site.toctocbr.com/portfolio",
        about: ["interiores", "decoração", "Itapema"]
      },
      {
        "@type": "CreativeWork",
        "@id": "https://site.toctocbr.com/portfolio#item-comercial-1",
        name: "Resort com arquitetura contemporânea — Fotografia de Arquitetura",
        genre: "fotografia de arquitetura",
        url: "https://site.toctocbr.com/portfolio",
        about: ["comercial", "resort", "Itajaí"]
      },
      {
        "@type": "CreativeWork",
        "@id": "https://site.toctocbr.com/portfolio#item-airbnb-1",
        name: "Casa para temporada — Fotografia para Airbnb",
        genre: "fotografia para Airbnb",
        url: "https://site.toctocbr.com/portfolio",
        about: ["Airbnb", "temporada", "Porto Belo"]
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://site.toctocbr.com/portfolio#breadcrumbs",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Início",
            item: "https://site.toctocbr.com/"
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Portfólio",
            item: "https://site.toctocbr.com/portfolio"
          }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Portfólio de Fotografia Imobiliária & Arquitetura — Toc Toc"
        description="Veja antes/depois e cases reais de fotografia de imóveis, arquitetura/interiores e vídeos. Clique para ver Serviços e solicitar orçamento."
        keywords="portfólio fotografia imobiliária, portfólio fotógrafo imobiliário, portfólio arquitetura, fotografia de interiores, vídeos imobiliários, filmmaker, Airbnb, Balneário Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas, Navegantes, Santa Catarina"
        canonicalUrl="https://site.toctocbr.com/portfolio"
        schema={schema}
        titleTemplate={null}
        ogImage="https://site.toctocbr.com/og-image.jpg"
        ogTitle="Portfólio Toc Toc | Fotografia Imobiliária & Arquitetura"
        ogDescription="Seleção de ensaios profissionais: imóveis residenciais, comerciais, arquitetura, interiores e Airbnb."
        twitterTitle="Portfólio Toc Toc | Fotografia Imobiliária & Arquitetura"
        twitterDescription="Trabalhos em SC: fotografia de imóveis, arquitetura/interiores, vídeos e Airbnb."
        ogImageAlt="Portfólio Toc Toc — fotografia imobiliária e arquitetura"
        robots="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        prefetchLinks={["/servicos", "/sobre", "/cidades-atendidas", "/contato"]}
      />

      <div className="min-h-screen bg-white">
        <TocTocHeader />
        <main>
          <div className="pt-24">
            <TocTocPortfolio />
          </div>
          <TocTocCTA />
        </main>
        <TocTocFooter />
      </div>
    </>
  );
};

export default Portfolio;
